if(!customElements.get('ezt-brand-strip')){customElements.define('ezt-brand-strip',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    this.abort=new AbortController();
    this.button=this.querySelector('.ezt-brands__pause');
    if(this.dataset.animate!=='true'||!this.button)return;
    this.button.hidden=false;
    this.classList.add('is-ready');
    this.button.addEventListener('click',()=>{
      const paused=this.dataset.paused!=='true';
      this.dataset.paused=String(paused);
      this.button.setAttribute('aria-pressed',String(paused));
      this.button.querySelector('span').textContent=paused?'Resume':'Pause';
      this.button.setAttribute('aria-label',paused?'Resume brand animation':'Pause brand animation');
      this.button.querySelector('svg').innerHTML=paused?'<path d="M5 3l8 5-8 5z"/>':'<path d="M4 3h3v10H4zM9 3h3v10H9z"/>';
    },{signal:this.abort.signal});
  }
  disconnectedCallback(){if(this.abort)this.abort.abort();this.abort=null;}
});}
